define('v3/Common/Components/ResizeableColumntext/ResizeableColumntext.Component',[
	'knockout',
	'text!v3/Common/Components/ResizeableColumntext/ResizeableColumntext.Component.html',
	'v3/Common/Models/enums'
],
function (ko, html) {
	function resizeablePupilname (params) {
		var self = this;
		self.extraLarge = params.extraLarge;
		self.large = params.large;
		self.medium = params.medium;
		self.tooltipOptions = ko.toJS(params.tooltipOptions);
		return self;
	}

	return { viewModel: resizeablePupilname, template: html };
});
